<template>
  <router-link :class="classModifiers" :to="routeTo">
    <div :class="iconClassModifiers" :style="iconStyleModifiers"></div>
    <div class="notification-item-dashboard__content">
      <div class="notification-item-dashboard__title">
        <div class="notification-item-dashboard__title-left">
          {{ data.contentJson.Title }}
        </div>
        <!-- TODO: confirm -->
        <template v-if="showPriceChange && !showTimeElapsed">
          <div class="notification-item-dashboard__title-right">
            {{ lastTradePriceAsCents }}¢
            <market-change-price :price="data.contentJson.PriceDelta"> </market-change-price>
          </div>
        </template>
      </div>
      <h5
        class="notification-item-dashboard__contract-name"
        v-if="showContractName"
        v-contract-name
      >
        {{ data.contentJson.ContractName }}
      </h5>
      <template v-if="showLevelChanged">
        <h5 class="notification-item-dashboard__market-name">
          {{ data.contentJson.Body }}
        </h5>
        <h5 class="notification-item-dashboard__level-changed-info" v-if="showNextLevelInfo">
          {{
            getProgressInfoTextForLevel(
              data.contentJson.NewTraderLevel,
              data.contentJson.ProfitablePredictions,
            )
          }}
        </h5>
      </template>
      <h5 v-else class="notification-item-dashboard__market-name">
        {{ data.contentJson.MarketName }}
      </h5>
      <template v-if="showPayout">
        <div class="notification-item-dashboard__payout">
          Payout: <span v-price-display.round2.fixed="data.contentJson.Cash"></span>
        </div>
      </template>
      <template v-if="showSellInfo">
        <div class="notification-item-dashboard__sell-info">
          {{ tradeTypeOperation }} {{ quantity }} {{ yesNoText }}
          <span class="notification-item-dashboard__sell-info-contract" v-if="tradeTypeShare">
            in {{ tradeTypeShare }}
          </span>
          <span class="notification-item-dashboard__sell-info-price"> @ {{ pricePerShare }}¢ </span>
        </div>
      </template>
      <template v-if="showSharesOwned">
        <div class="notification-item-dashboard__shares">
          {{ sharesOwned }} {{ yesNoText }} Share<template v-if="sharesOwned > 1">s</template> Owned
        </div>
      </template>
      <div class="notification-item-dashboard__time-elapsed" v-if="showTimeElapsed">
        {{ timeElapsed }}
      </div>
      <button
        @click.prevent.stop="onClose"
        v-show="closeButton"
        class="notification-item-dashboard__close"
      ></button>
    </div>
  </router-link>
</template>

<script src="./notification-item-dashboard.js"></script>
<style src="./notification-item-dashboard.scss" lang="scss"></style>
